import {FC, useEffect, useState} from 'react'

import {PopupCard} from '@/components/common/popup/PopupCard'
import {useTrademarkVerificationContent} from '@/content/trademarkVerification'
import {useTranslation} from '@/i18n'
import {analytics} from '@/utils/tracking/analytics'

type MultiCountryDiscountPopupProps = {
  isActive: boolean
  isClosed: boolean
  setIsClosed: () => void
}

export const MultiCountryDiscountPopup: FC<
  React.PropsWithChildren<MultiCountryDiscountPopupProps>
> = ({isActive, isClosed, setIsClosed}) => {
  const {t} = useTranslation()
  const {imageSrc, imageAlt, title, description} =
    useTrademarkVerificationContent().markets.discount
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (isActive && !isVisible) {
      setIsVisible(true)
      analytics.track('Discount banner is visible')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive])

  const closeDiscountBanner = () => {
    setIsClosed()
    analytics.track('Discount banner is closed')
  }

  return !isClosed ? (
    <PopupCard
      title={t(title)}
      description={description}
      imageSrc={imageSrc}
      imageAlt={imageAlt}
      isVisible={isVisible}
      onClose={closeDiscountBanner}
    />
  ) : null
}
